var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMeetingTitle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 640 640"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.001 544a16 16 0 01-15.385-20.396l32-112a16.002 16.002 0 014.071-6.918l352-352c6.248-6.249 16.379-6.249 22.627 0l80 80c6.249 6.248 6.249 16.379 0 22.627l-352 352a15.996 15.996 0 01-6.918 4.071l-112 32c-1.45.415-2.929.616-4.395.616zm46.245-119.618l-22.949 80.322 80.322-22.949L521.373 144 464 86.627 126.246 424.382zM560 608H80c-8.836 0-16-7.163-16-16s7.164-16 16-16h480c8.837 0 16 7.163 16 16s-7.163 16-16 16z"
  })));
}

export default SvgMeetingTitle;